import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AnimationOptions, LottieModule } from 'ngx-lottie';
import { EarlyCheckInReservationRepository } from './store/early-check-in-reservation.repository';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    LottieModule,
  ],
})
export class AppComponent implements OnInit {
  public isCheckInLoading$?: Observable<boolean>;

  constructor(
    private earlyCheckInRepository: EarlyCheckInReservationRepository
  ) {}

  ngOnInit() {
    this.isCheckInLoading$ = this.earlyCheckInRepository.isLoading$;
    this.isCheckInLoading$.subscribe((x) => {
      console.log('isCheckInLoading mode change to:', x);
    });
  }
  public title = 'avis-rent-kiosk';

  public lottieOptions: AnimationOptions = {
    path: '/assets/lotties/car-loading.json',
  };
  public lottieCheckInStyles: Partial<CSSStyleDeclaration> = {
    margin: '350px auto',
    width: '200px',
    height: '200px',
   
  };
}
